export const INSTITUTIONAL_LINKS = [
  { href: "/sobre", label: "Sobre" },
  { href: "/como-jogar", label: "Como jogar" },
  { href: "/contato", label: "Contato" },
  { href: "/privacidade", label: "Privacidade" },
  { href: "/termos", label: "Termos" },
];

export function SiteFooter() {
  return (
    <footer className="portal-footer site-footer">
      <span className="site-footer-brand">Party Games</span>
      <nav className="site-footer-links" aria-label="Links institucionais">
        {INSTITUTIONAL_LINKS.map((link) => (
          <a href={link.href} key={link.href}>
            {link.label}
          </a>
        ))}
      </nav>
      <p>Feito para jogar com amigos.</p>
    </footer>
  );
}
